import { CreateUserBundleMetaInterface } from "../interfaces/UserBundleMetaInterface/CreateUserBundleMetaInterface";
import { UserBundleMetaInterface } from "../interfaces/UserBundleMetaInterface/UserBundleMetaInterface";
import BaseService from "./BaseService";

export class UserBundleMetaService extends BaseService<UserBundleMetaInterface, CreateUserBundleMetaInterface>{ 
    constructor(){
        let url: string = '/user-bundle-meta/admin'
        super(url)
    }
}